<template>
  <div class="component-product-affiliate">
    <div class="title pt-6">Cadastrar coprodutor</div>
    <form-group
      v-model="form.email"
      id="email"
      type="email"
      class="pt-5"
      label="E-mail do Coprodutor"
      placeholder="Digite o e-mail"
      :errors="errors.email"
    />
    <span class="small-text text-secondary"
      >O Coprodutor precisa possuir cadastro completo utilizando este
      e-mail.</span
    >

    <form-group
      class="mt-6"
      id="qty_months"
      v-model="form.qty_months"
      select
      :options="[
        { id: 1, name: '1 mês' },
        { id: 2, name: '2 meses' },
        { id: 3, name: '3 meses' },
        { id: 6, name: '6 meses' },
        { id: 12, name: '1 ano' },
        { id: 24, name: '2 anos' },
        { id: 120, name: '10 anos' }
      ]"
      label="Tempo de contrato"
      placeholder="Tempo de contrato"
      :errors="errors.qty_months"
    />
    <span class="small-text text-secondary">
      Após esse período, o Coprodutor deixará de receber comissão.
    </span>

    <!-- <hr class="mb-6" />

    <h6 class="secondary-title-subtitle mb-6">
      Receber comissões das seguintes vendas:
    </h6>

    <form-group
      v-model="form.sell_product"
      id="sell_product"
      checkboxes
      :options="[{ id: true, name: 'Vendas do produtor' }]"
      :errors="errors.sell_product"
    />
    <form-group
      v-model="form.sell_affiliate"
      id="sell_affiliate"
      checkboxes
      :options="[{ id: true, name: 'Vendas de afiliados' }]"
      :errors="errors.sell_affiliate"
    /> -->

    <hr class="my-6" />

    <div class="my-5">
      Porcentagem das comissões
    </div>
    <!-- I use input type tel form workaround an vue-the-mask error with input type number -->
    <form-group
      v-model="form.tax_product"
      id="tax_product"
      label="Porcentagem da comissão do Coprodutor"
      placeholder="0,00%"
      type="text"
      :errors="errors.tax_product"
      is-money
      :money-config="{
        prefix: '',
        precision: 1
      }"
    />

    <!-- <form-group
      v-if="form.sell_affiliate[0]"
      v-model="form.fees_affiliate"
      id="fees_affiliate"
      class="mt-6"
      label="Porcentagem para vendas do afiliado"
      placeholder="0,00%"
      :maxLength="4"
      type="number"
      :errors="errors.fees_affiliate"
    />
    <span v-if="form.sell_affiliate[0]" class="small-text text-secondary">
      Esta porcentagem será aplicada somente nas vendas feitas por afiliados.
    </span> -->

    <div class="d-flex align-items-center pt-5 mb-5">
      <b-form-checkbox
        switch
        class="mr-5 text-switch"
        id="product-status"
        v-model="form.payment_recurrence"
        >Continuar pagando comissões a Coprodutores, após o término do contrato,
        pelas recorrências de vendas feitas durante a vigência
        dele.</b-form-checkbox
      >
    </div>

    <hr class="my-6" />

    <div class="mt-5">
      Termos de uso da Coprodução
    </div>

    <div class="description mb-6">
      Ao estabelecerem uma relação de Coprodução, Produtor e Coprodutor
      reconhecem e concordam com as regras e disposições da Blitzpay, que estão
      descritas abaixo:
    </div>

    <div class="card overflow-y-scroll mb-6">
      <div class="card-body overflow-auto">
        <ul>
          <li>
            A Blitzpay não possui qualquer responsabilidade e/ou gerência sobre
            a relação estabelecida entre Produtor e Coprodutor, se limitando a
            disponibilizar ferramentas na Plataforma Blitzpay que possibilitam
            que as partes configurem regras de comissionamento decorrentes da
            relação estabelecida, bem como seu prazo de duração;
          </li>
          <li>
            Tendo em vista que relação de Coprodução apenas é estabelecida
            mediante aceite formal do Coprodutor quanto ao pedido de Coprodução
            enviado pelo Produtor, tal relação apenas será desconstituída por
            meio de solicitação de cancelamento de Coprodução feita pelo
            Produtor e devidamente aceita pelo Coprodutor. Ou caso a relação de
            Coprodução tenha um período de duração determinado e este período
            chegue ao fim;
          </li>
          <li>
            Uma vez que a relação de Coprodução for finalizada, o Coprodutor não
            receberá mais comissões sobre vendas, mesmo que estas sejam futuras
            cobranças agendadas de recorrências de produtos de Assinatura ou de
            parcelas de produtos pagos via Parcelamento Inteligente;
          </li>
          <li>
            A relação de Coprodução também será considerada terminada caso o
            produto/conteúdo sobre o qual incida a Coprodução seja removido da
            Plataforma. Cabe frisar que, caso qualquer das ações de cancelamento
            da Coprodução represente eventual violação de acordos firmados entre
            as partes, a Blitzpay não será responsabilizada e apenas atuará
            mediante determinação judicial e/ou apresentação de acordo
            resolutivo assinado pelas partes com reconhecimento de firmas;
          </li>
          <li>
            O usuário que cadastra o produto na Blitzpay possui total e
            irrestrita responsabilidade sobre o produto e conteúdo a ele
            associado, conforme disposto nos Termos de Uso da Plataforma
            devidamente aceito pelo usuário, independente de quantos
            Coprodutores estiverem vinculados ao produto/conteúdo. Isto inclui,
            mas não se limita, a responsabilidades cíveis, consumeristas,
            tributárias, fiscais, criminais e de suporte ao consumidor;
          </li>
          <li>
            Por sua vez, o Coprodutor, que também deve ser usuário da Plataforma
            Blitzpay, possuindo conta, está sujeito às disposições dos Termos de
            Uso e Políticas da Plataforma;
          </li>
          <li>
            Em sendo estabelecida a relação de Coprodução, as partes ficam
            cientes de que toda a receita decorrente das vendas do
            produto/conteúdo que seria gerada para o Produtor agora será
            dividida entre o Produtor e Coprodutor(es) associados, conforme
            regras de comissionamento estabelecidas entre partes e refletidas
            nas configurações da Plataforma. Isto também se aplica às receitas
            geradas por afiliados;
          </li>
          <li>
            Em que pese não ser obrigatório, é recomendável que Produtor e
            Coprodutor firmem contratos e/ou acordos que estabeleçam claramente
            as regras, diretrizes, obrigações e responsabilidades das partes,
            bem como titularidade sobre direitos do conteúdo, imagem e demais
            temas relevantes que possam impactar de alguma forma a relação
            existente. Vale ressaltar que a Blitzpay não possui qualquer
            responsabilidade sobre tais instrumentos, caso existam, e tampouco é
            uma instância de revisão ou validação destes, sendo esta uma mera
            recomendação;
          </li>
          <li>
            Por fim, ao marcar as opções, Produtor e Coprodutor concordam com
            todas as disposições acima, em especial, quanto a ausência de
            responsabilidade da Blitzpay quanto aos desdobramentos do
            relacionamento de Coprodução ora estabelecido entre as partes.
          </li>
        </ul>
      </div>
    </div>

    <b-form-checkbox
      v-model="form.accepted_terms"
      id="accepted_terms"
      class="accept-terms"
    >
      Li e aceito os termos e condições da coprodução.
    </b-form-checkbox>

    <div class="d-none d-lg-flex justify-content-between my-9">
      <button class="btn btn-outline-secondary" @click="$router.go(-1)">
        Cancelar
      </button>

      <button
        class="btn btn-primary"
        :class="{ 'btn-secondary': !canMoveFoward }"
        :disabled="!canMoveFoward"
        @click="$emit('submit')"
      >
        <loading :show="loading">
          Salvar
        </loading>
      </button>
    </div>

    <div class="d-lg-none my-9">
      <div class="pb-5">
        <button
          class="btn btn-block btn-primary"
          :class="{ 'btn-secondary': !canMoveFoward }"
          :disabled="!canMoveFoward"
          @click="$emit('submit')"
        >
          <loading :show="loading"> Salvar</loading>
        </button>
      </div>
      <button
        class="btn btn-block btn-outline-secondary"
        @click="$router.go(-1)"
      >
        Cancelar
      </button>
    </div>
  </div>
</template>
<script>
import Loading from "../../Loading.vue";
export default {
  components: { Loading },
  props: {
    form: {
      type: Object,
      default: () => {}
    },
    errors: {
      type: Object,
      default: () => {}
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    canMoveFoward() {
      return (
        this.form.email &&
        this.form.qty_months !== null &&
        this.form.accepted_terms &&
        this.form.tax_product
      );
    }
  }
};
</script>
<style lang="scss" scoped>
@import "@/assets/scss/_variables.scss";

.component-product-affiliate {
  .title {
    color: rgba(59, 59, 74, 0.9);
    font-size: 24px;
    font-weight: 400;
  }

  .card {
    background: #fff !important;
    box-shadow: 0px 0px 12px rgba(0, 0, 0, 0.15) !important;
    max-height: 160px;
    font-size: 14px;
    border-radius: 4px;
    border: none;
    color: #928f98;

    @media screen and (max-width: 768px) {
      max-height: 350px;
    }

    ul {
      padding-bottom: 16px;
      padding-left: 16px;
    }

    .card-body {
      scrollbar-width: thin;

      &::-webkit-scrollbar {
        background-color: unset;
        border-radius: 0 4px 4px 0;
      }
      &::-webkit-scrollbar-thumb {
        background-color: #928f98;
        border-radius: 10px;
        height: 10px;
        border: 5px solid white;
      }
    }
  }

  .text-switch {
    color: rgba(59, 59, 74, 0.9);
    font-size: 15px;
  }

  .description {
    color: rgba(119, 120, 142, 0.87);
    font-size: 12px;
  }

  .accept-terms {
    color: rgba(59, 59, 74, 0.9);
    font-size: 15px;
  }
}
</style>
